export const STORE_ORDER_REASON = {
  EXPIRED: 'STORE_ORDER_EXPIRED',
  NOT_PAYMENT: 'STORE_ORDER_NOT_PAYMENT',
} as const

export type StoreOrderFinancingReason = typeof STORE_ORDER_REASON[keyof typeof STORE_ORDER_REASON]

const STORE_ORDER_REASON_ALERT_KEYS: Record<StoreOrderFinancingReason, string> = {
  [STORE_ORDER_REASON.EXPIRED]: 'customer.equipment_step.store_order_reason_alert.expired_description',
  [STORE_ORDER_REASON.NOT_PAYMENT]: 'customer.equipment_step.store_order_reason_alert.not_payment_description',
}

export interface StoreOrderSaveErrorConfig {
  messageKey: string
  markExpired?: boolean
  showFieldError?: boolean
}

// reason_codes retornados no save de hardware — extensível para novos status.
export const STORE_ORDER_SAVE_ERROR_CONFIG: Record<string, StoreOrderSaveErrorConfig> = {
  [STORE_ORDER_REASON.EXPIRED]: {
    messageKey: 'customer.equipment_step.store_order.errors.order_expired',
    markExpired: true,
  },
  [STORE_ORDER_REASON.NOT_PAYMENT]: {
    messageKey: 'customer.equipment_step.store_order.errors.order_not_payment',
    showFieldError: true,
  },
}

export function isStoreOrderFinancingReason(reason: string | null | undefined): reason is StoreOrderFinancingReason {
  return reason === STORE_ORDER_REASON.EXPIRED || reason === STORE_ORDER_REASON.NOT_PAYMENT
}

export function getStoreOrderReasonAlertDescriptionKey(reason: StoreOrderFinancingReason): string {
  return STORE_ORDER_REASON_ALERT_KEYS[reason]
}
